var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReturnsRedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.34099 2.50093C5.56229 2.72223 5.56229 3.08102 5.34099 3.30232L2.68251 5.96081L5.34099 8.6193C5.56229 8.84059 5.56229 9.19939 5.34099 9.42068C5.1197 9.64198 4.7609 9.64198 4.53961 9.42068L1.48043 6.3615C1.25913 6.14021 1.25913 5.78141 1.48043 5.56011L4.53961 2.50093C4.7609 2.27964 5.1197 2.27964 5.34099 2.50093Z",
    fill: "#E50B20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.31445 5.96081C1.31445 5.64785 1.56816 5.39414 1.88112 5.39414H10.5488C11.6457 5.39414 12.6976 5.82987 13.4732 6.60547C14.2488 7.38106 14.6845 8.433 14.6845 9.52985C14.6845 10.6267 14.2488 11.6786 13.4732 12.4542C12.6976 13.2298 11.6457 13.6656 10.5488 13.6656H4.9403C4.62734 13.6656 4.37363 13.4119 4.37363 13.0989C4.37363 12.7859 4.62734 12.5322 4.9403 12.5322H10.5488C11.3451 12.5322 12.1087 12.2159 12.6718 11.6529C13.2349 11.0898 13.5512 10.3261 13.5512 9.52985C13.5512 8.73357 13.2349 7.96991 12.6718 7.40685C12.1087 6.8438 11.3451 6.52748 10.5488 6.52748H1.88112C1.56816 6.52748 1.31445 6.27377 1.31445 5.96081Z",
    fill: "#E50B20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReturnsRedIcon);
export default __webpack_public_path__ + "static/media/returns-red-icon.7fea8b36191c3d20b1ad2d6c91e4ec5b.svg";
export { ForwardRef as ReactComponent };